
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('项目')">
              <a-select v-model="queryParam.projectCode" :placeholder="$t('请选择项目')">
                <a-select-option v-for="item in list" :value="item.code" :key="item.code">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <!-- <a-button type="primary" icon="download" @click="handleExportXls('物联配置')" style="margin-left: 8px"
                >导出</a-button
              >
              <a-upload
                name="file"
                :showUploadList="false"
                :multiple="false"
                :headers="tokenHeader"
                :action="importExcelUrl"
                @change="handleImportExcel"
              >
                <a-button type="primary" icon="import" style="margin-left: 8px">导入</a-button>
              </a-upload> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- table区域-begin -->
    <div>
      <a-tabs :activeKey="activeKey" :animated="false" @change="handleChange">
        <a-tab-pane key="1" :tab="$t('压力计')">
          <div>
            <a-table
              :columns="columns1"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true }"
              size="middle"
              @change="handleTableChange"
            >
              <span slot="action" slot-scope="text, record">
                <a @click="handleHistory(record)" :disabled="!record.nodeIotConfig">{{ $t('历史数据') }}</a>
                <a-divider type="vertical" />
                <a-popconfirm :title="$t('确定解绑吗?')" @confirm="() => handleUnbind(record)">
                  <a :disabled="!record.nodeIotConfig">{{ $t('解绑') }}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" :tab="$t('水表')">
          <div>
            <a-table
              :columns="columns2"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true }"
              size="middle"
              @change="handleTableChange"
            >
              <span slot="action" slot-scope="text, record">
                <a @click="handleHistory(record)" :disabled="!record.nodeIotConfig">{{ $t('历史数据') }}</a>
                <a-divider type="vertical" />
                <a-popconfirm :title="$t('确定解绑吗?')" @confirm="() => handleUnbind(record)">
                  <a :disabled="!record.nodeIotConfig">{{ $t('解绑') }}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" :tab="$t('阀门')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true }"
              size="middle"
              @change="handleTableChange"
            >
              <span slot="action" slot-scope="text, record">
                <a @click="handleHistory(record)" :disabled="!record.nodeIotConfig">{{ $t('历史数据') }}</a>
                <a-divider type="vertical" />
                <a-popconfirm :title="$t('确定解绑吗?')" @confirm="() => handleUnbind(record)">
                  <a :disabled="!record.nodeIotConfig">{{ $t('解绑') }}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="4" :tab="$t('消防栓')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true }"
              size="middle"
              @change="handleTableChange"
            >
              <span slot="action" slot-scope="text, record">
                <a @click="handleHistory(record)" :disabled="!record.nodeIotConfig">{{ $t('历史数据') }}</a>
                <a-divider type="vertical" />
                <a-popconfirm :title="$t('确定解绑吗?')" @confirm="() => handleUnbind(record)">
                  <a :disabled="!record.nodeIotConfig">{{ $t('解绑') }}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="5" :tab="$t('水塔')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true }"
              size="middle"
              @change="handleTableChange"
            >
              <span slot="action" slot-scope="text, record">
                <a @click="handleHistory(record)" :disabled="!record.nodeIotConfig">{{ $t('历史数据') }}</a>
                <a-divider type="vertical" />
                <a-popconfirm :title="$t('确定解绑吗?')" @confirm="() => handleUnbind(record)">
                  <a :disabled="!record.nodeIotConfig">{{ $t('解绑') }}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="6" :tab="$t('加压泵')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true }"
              size="middle"
              @change="handleTableChange"
            >
              <span slot="action" slot-scope="text, record">
                <a @click="handleHistory(record)" :disabled="!record.nodeIotConfig">{{ $t('历史数据') }}</a>
                <a-divider type="vertical" />
                <a-popconfirm :title="$t('确定解绑吗?')" @confirm="() => handleUnbind(record)">
                  <a :disabled="!record.nodeIotConfig">{{ $t('解绑') }}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="7" :tab="$t('流量计')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true }"
              size="middle"
              @change="handleTableChange"
            >
              <span slot="action" slot-scope="text, record">
                <a @click="handleHistory(record)" :disabled="!record.nodeIotConfig">{{ $t('历史数据') }}</a>
                <a-divider type="vertical" />
                <a-popconfirm :title="$t('确定解绑吗?')" @confirm="() => handleUnbind(record)">
                  <a :disabled="!record.nodeIotConfig">{{ $t('解绑') }}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="8" :tab="$t('液位计')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true }"
              size="middle"
              @change="handleTableChange"
            >
              <span slot="action" slot-scope="text, record">
                <a @click="handleHistory(record)" :disabled="!record.nodeIotConfig">{{ $t('历史数据') }}</a>
                <a-divider type="vertical" />
                <a-popconfirm :title="$t('确定解绑吗?')" @confirm="() => handleUnbind(record)">
                  <a :disabled="!record.nodeIotConfig">{{ $t('解绑') }}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <editModal ref="editModalRef" @ok="modalFormOk" />
    <historyDataModal ref="historyDataModalRef" />
  </a-card>
</template>
  
  <script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { postAction, getAction, deleteAction } from '@/api/manage'
import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import editModal from './editModal.vue'
import historyDataModal from './historyDataModal.vue'
import Vue from 'vue'

export default {
  name: 'IotIndex',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    editModal,
    historyDataModal,
  },
  data() {
    return {
      url: {
        list: '/jeecg-gis/nodeIotConfig/page',
        unbind: '/jeecg-gis/nodeIotConfig/delete',
        exportXlsUrl: '/jeecg-gis/nodeIotConfig/exportXls',
        importExcelUrl: 'jeecg-gis/nodeIotConfig/importExcel',
        listProjectTopology: '/jeecg-gis/topology/topology/listProjectTopology',
        queryById: '/jeecg-gis/nodeIotConfig/get',
      },
      dictOptions: {},
      superFieldList: [],
      list: [],
      activeKey: '1',
      type: {
        1: 'NODE_PIPELINE_TYPE_PM', //压力计
        2: 'NODE_PIPELINE_TYPE_METER', //水表
        3: 'NODE_PIPELINE_TYPE_VALVE', //阀门
        4: 'NODE_PIPELINE_TYPE_HYDRANT', //消防栓
        5: 'NODE_PIPELINE_TYPE_TOWER', //水塔
        6: 'NODE_PIPELINE_TYPE_BOOSTER_PUMP_STATION', //加压泵
        7: 'NODE_PIPELINE_TYPE_FM', //流量计
        8: 'NODE_PIPELINE_TYPE_WM', //液位计
      },
    }
  },
  mounted() {
    this.getlistProjectTopology()
    let data = Vue.ls.get('GIS_TOPOLOGY_DATA').topology
    this.$set(this.queryParam, 'projectCode', data.projectCode)
    this.loadData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    // i18n：表头使用 computed 以响应语言切换
    columns1() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('代码'),
          align: 'center',
          dataIndex: 'code',
          customRender: (t, r, index) => {
            return r.node && r.node.code
          },
        },
        {
          title: this.$t('名称'),
          align: 'center',
          dataIndex: 'name',
          customRender: (t, r, index) => {
            return r.node && r.node.name
          },
        },
        {
          title: this.$t('类型'),
          align: 'center',
          dataIndex: 'type',
          customRender: (t, r, index) => {
            return r.node && filterDictTextByCache('node_type', r.node.type)
          },
        },
        {
          title: this.$t('物联代码'),
          align: 'center',
          dataIndex: 'deviceId',
          customRender: (t, r, index) => {
            return r.nodeIotConfig && r.nodeIotConfig.deviceId
          },
        },
        {
          title: this.$t('转换系数'),
          align: 'center',
          dataIndex: 'conversionCoefficient',
          customRender: (t, r, index) => {
            return r.nodeIotConfig && r.nodeIotConfig.conversionCoefficient
          },
        },
        {
          title: this.$t('压力'),
          align: 'center',
          dataIndex: 'pvalue',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.pvalue
          },
        },
        {
          title: this.$t('温度'),
          align: 'center',
          dataIndex: 'tepvalue',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.tepvalue
          },
        },
        {
          title: this.$t('电压'),
          align: 'center',
          dataIndex: 'battery',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.battery
          },
        },
        {
          title: this.$t('信号'),
          align: 'center',
          dataIndex: 'signDb',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.signDb
          },
        },
        {
          title: this.$t('最新上报时间'),
          align: 'center',
          dataIndex: 'metertime',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.metertime
          },
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    columns2() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('代码'),
          align: 'center',
          dataIndex: 'code',
          customRender: (t, r, index) => {
            return r.node && r.node.code
          },
        },
        {
          title: this.$t('名称'),
          align: 'center',
          dataIndex: 'name',
          customRender: (t, r, index) => {
            return r.node && r.node.name
          },
        },
        {
          title: this.$t('类型'),
          align: 'center',
          dataIndex: 'type',
          customRender: (t, r, index) => {
            return r.node && filterDictTextByCache('node_type', r.node.type)
          },
        },
        {
          title: this.$t('表编号'),
          align: 'center',
          dataIndex: 'meterId',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterId
          },
        },
        {
          title: this.$t('累计用量'),
          align: 'center',
          dataIndex: 'meterTotalUse',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterTotalUse
          },
        },
        {
          title: this.$t('结算日流量'),
          align: 'center',
          dataIndex: 'meterJsrUse',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterJsrUse
          },
        },
        {
          title: this.$t('表端剩余金额'),
          align: 'center',
          dataIndex: 'meterRemainNum',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterRemainNum
          },
        },
        {
          title: this.$t('电压'),
          align: 'center',
          dataIndex: 'meterBatteryVoltage',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterBatteryVoltage
          },
        },
        {
          title: this.$t('信号'),
          align: 'center',
          dataIndex: 'meterSignalStrength',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.meterSignalStrength
          },
        },
        {
          title: this.$t('最新上报时间'),
          align: 'center',
          dataIndex: 'sysTime',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.sysTime
          },
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('代码'),
          align: 'center',
          dataIndex: 'code',
          customRender: (t, r, index) => {
            return r.node && r.node.code
          },
        },
        {
          title: this.$t('名称'),
          align: 'center',
          dataIndex: 'name',
          customRender: (t, r, index) => {
            return r.node && r.node.name
          },
        },
        {
          title: this.$t('类型'),
          align: 'center',
          dataIndex: 'type',
          customRender: (t, r, index) => {
            return r.node && filterDictTextByCache('node_type', r.node.type)
          },
        },
        {
          title: this.$t('物联代码'),
          align: 'center',
          dataIndex: 'nodeCode',
          customRender: (t, r, index) => {
            return r.nodeIotConfig && r.nodeIotConfig.nodeCode
          },
        },
        {
          title: this.$t('转换系数'),
          align: 'center',
          dataIndex: 'conversionCoefficient',
          customRender: (t, r, index) => {
            return r.nodeIotConfig && r.nodeIotConfig.conversionCoefficient
          },
        },
        {
          title: this.$t('最新上报时间'),
          align: 'center',
          dataIndex: 'lastUpdateTime',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.lastUpdateTime
          },
        },
        {
          title: this.$t('最新上报值'),
          align: 'center',
          dataIndex: 'value',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.value
          },
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  methods: {
    handleChange(e) {
      this.activeKey = e
      this.loadData()
    },
    getlistProjectTopology() {
      postAction(this.url.listProjectTopology).then(res => {
        if (res.success) {
          this.list = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    loadData() {
      let params = {
        projectCode: this.queryParam.projectCode,
        page: {
          current: this.ipagination.current,
          size: this.ipagination.pageSize,
        },
        nodeType: this.type[this.activeKey],
      }
      postAction(this.url.list, params).then(res => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    searchReset() {
      let topoData = Vue.ls.get('GIS_TOPOLOGY_DATA')
      if (topoData && topoData.topology) {
        this.$set(this.queryParam, 'projectCode', topoData.topology.projectCode)
      }
      this.ipagination.current = 1
      this.loadData(1)
    },
    // 历史数据
    handleHistory(record) {
      this.$refs.historyDataModalRef.init(record)
    },
    // 解绑
    handleUnbind(record) {
      deleteAction(this.url.unbind, { id: record.nodeIotConfig.id }).then(res => {
        if (res.success) {
          this.loadData()
          this.$message.success(res.message)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 编辑
    handleEdit(record) {
      postAction(this.url.queryById, { projectCode: record.node.projectCode, nodeCode: record.node.code }).then(res => {
        if (res.success) {
          this.$nextTick(() => {
            this.$refs.editModalRef.init(res.result)
            this.$refs.editModalRef.title = this.$t('编辑')
            this.$refs.editModalRef.disableSubmit = false
          })
        } else {
          this.$message.warning(res.message)
        }
      })
    },
  },
}
</script>
  <style scoped>
@import '~@assets/less/common.less';
</style>